import ShippingPrivacyMore from '@/components/ShippingPrivacy/ShippingPrivacyMore';
import { ShippingRuleClassEnum } from '@/constants/enum';
import { IRule } from '@/types/newSetup.type';

interface IProps {
  rule?: IRule;
}

function ShippingPrivacy(props: IProps) {
  const rule = props.rule;
  const { ShippingPrivacyContainer, ShippingPrivacyContent, ShippingPrivacyLink } = ShippingRuleClassEnum;

  return (
    <>
      {rule?.privacyPageText ? (
        <div className={ShippingPrivacyContainer}>
          <div className={ShippingPrivacyContent}>
            <p>
              {rule?.privacyPageUrl ? (
                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                <a className={ShippingPrivacyLink}>{rule?.privacyPageText}</a>
              ) : (
                <span className={ShippingPrivacyLink}>{rule?.privacyPageText}</span>
              )}
              <ShippingPrivacyMore rule={rule} />
            </p>
          </div>
        </div>
      ) : null}
    </>
  );
}

export default ShippingPrivacy;
